import script from "./settings-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./settings-menu.vue?vue&type=script&setup=true&lang=js"

import "./settings-menu.vue?vue&type=style&index=0&id=b4d89324&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4d89324"]])

export default __exports__